import { Navigate } from 'react-router-dom';

const Main = () => {
  return <Navigate to="/app" />;
};

export default Main;
